import { buildUseCurrentBreakpointHook } from "@thelabnyc/thelabui/src/hooks/layout";

import { mediaQueries } from "../styles/media-queries";

/**
 * Hooks for components which need to react ot the current breakpoint.
 */
export const useCurrentBreakpoint = buildUseCurrentBreakpointHook(mediaQueries);
